// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"139":"metadata-sidebar","206":"skills-sidebar","551":"activity-sidebar","716":"details-sidebar","751":"versions-sidebar"}[chunkId] + "." + {"139":"ec6f51d8","206":"84a56c5e","551":"67bf3dc3","716":"16ac5694","751":"a4d7d8b3"}[chunkId] + ".chunk.css";
};